const isMacPlatform = typeof navigator !== 'undefined' && /Mac|iPhone|iPad/i.test(navigator.platform || navigator.userAgent || '');

export const AI_ASSISTANT_SHORTCUT_LABEL = isMacPlatform ? '⌘ + K' : 'Ctrl + K';

export const isAiAssistantShortcut = event => (event.metaKey || event.ctrlKey) && !event.altKey && !event.shiftKey && event.key?.toLowerCase() === 'k';
